/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.21.0
 * @since 1.21.0
 */

import styled from 'styled-components';

import { InputContainerStyled } from '../../Input/styled/InputStyled';

export const TextareaStyled = styled(InputContainerStyled)`
    textarea {
        padding: 20px;
    }
`;
